(function () {

  // Lee una cookie por nombre (para _fbp/_fbc del pixel de Meta)
  function cookie(n) {
    var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : undefined;
  }
  var CFG = window.PCL_COD || {};
  var form = document.getElementById('cod-form');
  if (!form) return;
  var otpToken = null, otpVerificado = false, telefonoVerificado = null;

  // --- Embudo del checkout: para no estar ciegos entre "inició checkout" y "compró" ---
  // Una sesión por pestaña. Cada paso se manda al backend (fire-and-forget); si falla, ni
  // se nota: es telemetría, jamás debe estorbar la compra.
  var sesion;
  try { sesion = sessionStorage.getItem('pcl_sesion'); } catch (e) {}
  if (!sesion) { sesion = Date.now().toString(36) + Math.random().toString(36).slice(2, 8); try { sessionStorage.setItem('pcl_sesion', sesion); } catch (e) {} }
  var resumenPedido = { producto: null, producto_id: null, monto: null };
  function pingEvento(paso) {
    try {
      fetch(CFG.backendUrl + '/cod/evento', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({
          sesion: sesion, paso: paso,
          producto: resumenPedido.producto, producto_id: resumenPedido.producto_id,
          monto: resumenPedido.monto,
          telefono: (paso === 'otp_solicitado' || paso === 'otp_verificado' || paso === 'pedido_creado') ? form.telefono.value : undefined,
        }),
      }).catch(function () {});
    } catch (e) {}
  }

  // --- Indicador corporativo minimalista (reemplaza el alert nativo) ---
  var _toast = document.getElementById('cod-toast'), _toastT = null;
  function aviso(texto, tipo) {
    if (!_toast) return;
    var c = tipo === 'error' ? { bg: '#fdecea', fg: '#b3261e' } : tipo === 'ok' ? { bg: '#e7f4ec', fg: '#276C45' } : { bg: '#eef2f7', fg: '#2b3a33' };
    _toast.textContent = texto;
    _toast.style.background = c.bg; _toast.style.color = c.fg;
    _toast.style.opacity = '1'; _toast.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(_toastT);
    _toastT = setTimeout(function () { _toast.style.opacity = '0'; _toast.style.transform = 'translateX(-50%) translateY(10px)'; }, 3800);
  }

  // --- Regiones y comunas desde el backend (el backend re-valida contra el listado completo) ---
  var COMUNAS = {};
  fetch(CFG.backendUrl + '/cod/comunas').then(function (r) { return r.json(); }).then(function (d) {
    COMUNAS = d || {};
    var rsel = form.region;
    Object.keys(COMUNAS).forEach(function (reg) {
      var o = document.createElement('option'); o.value = reg; o.textContent = reg; rsel.appendChild(o);
    });
  }).catch(function () {});
  form.region.addEventListener('change', function () {
    var csel = form.comuna; csel.innerHTML = '<option value="">Elige…</option>';
    (COMUNAS[form.region.value] || []).forEach(function (c) {
      var o = document.createElement('option'); o.value = c; o.textContent = c; csel.appendChild(o);
    });
    actualizarDespacho();
  });

  // --- Despacho: gratis en RM, a regiones solo la diferencia (tabla del backend) ---
  var DESPACHO = { recargoPorComuna: {}, recargoDefault: 0 };
  var zonaNoServible = false;
  var productTotalCents = 0; // subtotal de productos (en "cents" de Shopify); lo llena el carrito
  fetch(CFG.backendUrl + '/cod/despacho').then(function (r) { return r.json(); })
    .then(function (d) { DESPACHO = d || DESPACHO; actualizarDespacho(); }).catch(function () {});
  // Gemelo de normalizar() del backend (src/cod/dropiGeo.js): mismas claves de comuna.
  function normalizarComuna(s) {
    return String(s || '').toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/Ñ/g, 'N').replace(/`/g, '').replace(/[^A-Z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }
  function recargoDeComuna(comuna) {
    if (!comuna) return { recargo: 0, servible: true, sinComuna: true };
    var v = DESPACHO.recargoPorComuna[normalizarComuna(comuna)];
    if (v === null) return { recargo: 0, servible: false };
    if (v === undefined) return { recargo: DESPACHO.recargoDefault || 0, servible: true };
    return { recargo: Number(v) || 0, servible: true };
  }
  // Recalcula la línea de envío y el total cuando cambia la comuna.
  function actualizarDespacho() {
    var val = document.getElementById('co-envio-val');
    var total = document.getElementById('co-total');
    var err = document.getElementById('cod-error');
    var d = recargoDeComuna(form.comuna && form.comuna.value);
    zonaNoServible = !d.servible;
    if (!d.servible) {
      if (val) { val.textContent = 'No disponible'; val.style.color = '#b3261e'; }
      if (err) { err.style.display = 'block'; err.textContent = 'Por ahora no hacemos pago contra entrega a tu zona. Escríbenos y vemos otra forma de envío.'; }
    } else {
      if (err) err.style.display = 'none';
      if (val) {
        if (d.recargo > 0) { val.textContent = money(d.recargo * 100); val.style.color = ''; }
        else { val.textContent = 'GRATIS 🎉'; val.style.color = ''; }
      }
    }
    if (total) total.textContent = money(productTotalCents + (d.servible ? d.recargo * 100 : 0));
    var btn = document.getElementById('btn-confirmar');
    if (btn && zonaNoServible) btn.disabled = true;
  }

  // --- Validación RUT (módulo 11) + teléfono chileno ---
  function limpiarRut(r) { return (r || '').replace(/[^0-9kK]/g, '').toUpperCase(); }
  function dvRut(cuerpo) { var s = 0, m = 2; for (var i = cuerpo.length - 1; i >= 0; i--) { s += +cuerpo[i] * m; m = m === 7 ? 2 : m + 1; } var x = 11 - (s % 11); return x === 11 ? '0' : x === 10 ? 'K' : '' + x; }
  function validarRut(r) { var l = limpiarRut(r); if (l.length < 2) return false; var c = l.slice(0, -1), d = l.slice(-1); return /^[0-9]+$/.test(c) && dvRut(c) === d; }
  function validarTel(t) { var d = (t || '').replace(/[^0-9]/g, ''); if (d.indexOf('56') === 0) d = d.slice(2); return /^9[0-9]{8}$/.test(d); }

  // --- Formato en vivo mientras se escribe ---
  function formatearRutLive(v) {
    var l = limpiarRut(v); if (l.length < 2) return l;
    var cuerpo = l.slice(0, -1), dv = l.slice(-1);
    return cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + dv;
  }
  form.rut.addEventListener('input', function () {
    this.value = formatearRutLive(this.value);
  });
  // El teléfono se normaliza al salir del campo (número completo → sin ambigüedad con el prefijo país).
  function formatearTelBlur(v) {
    var d = (v || '').replace(/[^0-9]/g, '');
    if (d.length > 9 && d.indexOf('56') === 0) d = d.slice(2); // quita código país si viene
    d = d.slice(0, 9);
    if (d.length !== 9) return v; // incompleto: deja lo que hay, la validación lo marca
    return '+56 9 ' + d.slice(1, 5) + ' ' + d.slice(5, 9);
  }
  form.telefono.addEventListener('blur', function () {
    this.value = formatearTelBlur(this.value);
  });

  function marcar(fieldId, ok) {
    var f = document.getElementById(fieldId);
    if (ok) f.classList.remove('invalid'); else f.classList.add('invalid');
    return ok;
  }
  function validarCampos() {
    var okN = marcar('f-nombre', form.nombre.value.trim().length > 2);
    var okR = marcar('f-rut', validarRut(form.rut.value));
    var okT = marcar('f-telefono', validarTel(form.telefono.value));
    var okReg = marcar('f-region', !!form.region.value);
    var okC = marcar('f-comuna', !!form.comuna.value);
    var okD = marcar('f-direccion', form.direccion.value.trim().length > 3);
    return okN && okR && okT && okReg && okC && okD;
  }
  ['nombre', 'rut', 'telefono', 'region', 'comuna', 'direccion'].forEach(function (n) {
    form[n].addEventListener('blur', function () { validarCampos(); toggleOtp(); });
  });
  form.comuna.addEventListener('change', function () { actualizarDespacho(); });

  function toggleOtp() {
    var box = document.getElementById('otp-box');
    if (validarTel(form.telefono.value)) box.classList.remove('hidden'); else box.classList.add('hidden');
  }

  // --- Google Places ---
  function cargarPlaces() {
    if (!CFG.mapsKey) return;
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' + CFG.mapsKey + '&libraries=places&language=es&region=CL&callback=pclInitPlaces';
    s.async = true; document.head.appendChild(s);
  }
  window.pclInitPlaces = function () {
    var mapEl = document.getElementById('cod-map');
    var hint = document.getElementById('cod-map-hint');
    var map = null, marker = null;
    function fijarLatLng(lat, lng) { form.lat.value = lat; form.lng.value = lng; }
    function mostrarMapa(lat, lng) {
      var pos = { lat: lat, lng: lng };
      mapEl.style.display = 'block'; hint.style.display = 'block';
      if (!map) {
        map = new google.maps.Map(mapEl, { center: pos, zoom: 16, mapTypeControl: false, streetViewControl: false, fullscreenControl: false });
        marker = new google.maps.Marker({ map: map, position: pos, draggable: true, animation: google.maps.Animation.DROP });
        marker.addListener('dragend', function () { var q = marker.getPosition(); fijarLatLng(q.lat(), q.lng()); });
      } else {
        map.setCenter(pos); marker.setPosition(pos);
      }
      google.maps.event.trigger(map, 'resize');
      map.setCenter(pos);
    }
    var ac = new google.maps.places.Autocomplete(document.getElementById('cod-direccion'), {
      componentRestrictions: { country: 'cl' }, fields: ['geometry', 'formatted_address'], types: ['address']
    });
    ac.addListener('place_changed', function () {
      var p = ac.getPlace();
      if (p.geometry) {
        var loc = p.geometry.location;
        fijarLatLng(loc.lat(), loc.lng());
        mostrarMapa(loc.lat(), loc.lng());
      }
      if (p.formatted_address) form.direccion.value = p.formatted_address;
    });
  };
  cargarPlaces();

  // --- Resumen del pedido ---
  function money(cents) { return '$' + (cents / 100).toLocaleString('es-CL'); }
  var itemsPedido = [];
  function pintarResumen(items) {
    itemsPedido = items;
    var cont = document.getElementById('co-items'), total = 0;
    cont.innerHTML = '';
    items.forEach(function (it) {
      total += it.line_price != null ? it.line_price : it.price * it.quantity;
      var d = document.createElement('div'); d.className = 'co-item';
      d.innerHTML = '<img src="' + (it.image || '') + '"><div><div>' + it.title + '</div><div style="color:#6b7a70">x' + it.quantity + '</div></div>';
      cont.appendChild(d);
    });
    productTotalCents = total;
    actualizarDespacho(); // pinta el total ya con el despacho de la comuna elegida (0 en RM)
  }
  // Saca el id de Dropi del SKU (DROPI-<id>[-<variacion>]) para el embudo por producto.
  function dropiIdDeSku(sku) { var m = /DROPI-(\d+)/i.exec(sku || ''); return m ? +m[1] : null; }
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    if (window.fbq && cart && cart.total_price) {
      fbq('track', 'InitiateCheckout', { value: cart.total_price / 100, currency: 'CLP', num_items: cart.item_count });
    }
    var primero = (cart.items || [])[0] || {};
    resumenPedido = {
      producto: primero.product_title || null,
      producto_id: dropiIdDeSku(primero.sku),
      monto: cart.total_price != null ? Math.round(cart.total_price / 100) : null,
    };
    pingEvento('checkout_view'); // llegó al carrito: el techo del embudo del lado nuestro
    pintarResumen(cart.items.map(function (i) { return { variant_id: i.variant_id, title: i.product_title, quantity: i.quantity, price: i.price, line_price: i.line_price, image: i.image }; }));
  }).catch(function () {});

  // --- OTP (SMS) con reenvío + cooldown ---
  var REENVIO_COOLDOWN = 30, _cdT = null;
  function iniciarCooldown() {
    var link = document.getElementById('btn-reenviar'), timer = document.getElementById('reenviar-timer');
    var t = REENVIO_COOLDOWN;
    link.style.pointerEvents = 'none'; link.style.opacity = '.45';
    timer.textContent = ' (disponible en ' + t + 's)';
    clearInterval(_cdT);
    _cdT = setInterval(function () {
      t--;
      if (t <= 0) { clearInterval(_cdT); timer.textContent = ''; link.style.pointerEvents = ''; link.style.opacity = ''; }
      else timer.textContent = ' (disponible en ' + t + 's)';
    }, 1000);
  }
  function enviarCodigo(esReenvio) {
    if (!validarTel(form.telefono.value)) { marcar('f-telefono', false); aviso('Revisa tu número de teléfono.', 'error'); return; }
    var sendBtn = document.getElementById('btn-enviar-otp');
    if (!esReenvio) { sendBtn.disabled = true; sendBtn.textContent = 'Enviando…'; }
    fetch(CFG.backendUrl + '/cod/otp/send', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ telefono: form.telefono.value }) })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok) {
          if (!esReenvio) pingEvento('otp_solicitado'); // pidió el SMS: el paso más ciego hasta ahora
          document.getElementById('otp-verify').style.display = 'block';
          sendBtn.textContent = 'Código enviado ✓'; sendBtn.disabled = true;
          iniciarCooldown();
          aviso(esReenvio ? 'Te reenviamos el código por SMS.' : 'Te enviamos un código por SMS.', 'ok');
        } else if (res.status === 429) {
          aviso('Espera unos segundos antes de pedir otro código.', 'info');
          if (!esReenvio) { sendBtn.disabled = false; sendBtn.textContent = 'Enviar código a mi teléfono'; }
        } else {
          aviso(res.j.error || 'No pudimos enviar el código, reintenta.', 'error');
          if (!esReenvio) { sendBtn.disabled = false; sendBtn.textContent = 'Reintentar envío'; }
        }
      })
      .catch(function () { aviso('Sin conexión con el servidor, reintenta.', 'error'); if (!esReenvio) { sendBtn.disabled = false; sendBtn.textContent = 'Reintentar envío'; } });
  }
  document.getElementById('btn-enviar-otp').addEventListener('click', function () { enviarCodigo(false); });
  document.getElementById('btn-reenviar').addEventListener('click', function (e) { e.preventDefault(); enviarCodigo(true); });

  document.getElementById('btn-verificar-otp').addEventListener('click', function () {
    fetch(CFG.backendUrl + '/cod/otp/check', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ telefono: form.telefono.value, codigo: form.codigo.value }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok && res.j.otpToken) {
          otpToken = res.j.otpToken; otpVerificado = true; telefonoVerificado = form.telefono.value;
          pingEvento('otp_verificado'); // verificó el SMS: superó el muro del OTP
          document.getElementById('otp-ok').style.display = 'block';
          document.getElementById('btn-confirmar').disabled = false;
          aviso('Teléfono verificado', 'ok');
        } else { aviso(res.j.error || 'Código incorrecto, revísalo.', 'error'); }
      })
      .catch(function () { aviso('No pudimos verificar, reintenta.', 'error'); });
  });

  // --- Submit ---
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validarCampos()) return;
    if (zonaNoServible) { aviso('Por ahora no hacemos pago contra entrega a tu zona.', 'error'); return; }
    if (!otpVerificado || form.telefono.value !== telefonoVerificado) { aviso('Primero verifica tu teléfono.', 'error'); return; }
    var btn = document.getElementById('btn-confirmar'); btn.disabled = true; btn.textContent = 'Procesando…';
    var payload = {
      items: itemsPedido.map(function (i) { return { variantId: i.variant_id, quantity: i.quantity, title: i.title }; }),
      cliente: {
        nombre: form.nombre.value.trim(), rut: form.rut.value, telefono: form.telefono.value,
        email: form.email.value || undefined, region: form.region.value, comuna: form.comuna.value,
        direccion: form.direccion.value.trim(), referencia: form.referencia.value.trim(),
        lat: form.lat.value ? +form.lat.value : null, lng: form.lng.value ? +form.lng.value : null
      },
      otpToken: otpToken,
      idempotencyKey: (Date.now() + '-' + Math.random().toString(36).slice(2)),
      // Cookies del pixel: mejoran mucho la coincidencia de la compra con el clic del anuncio
      fbp: cookie('_fbp'), fbc: cookie('_fbc')
    };
    fetch(CFG.backendUrl + '/cod/order', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok) { pingEvento('pedido_creado'); fetch('/cart/clear.js', { method: 'POST' }).finally(function () { location.href = '/pages/gracias'; }); }
        else { btn.disabled = false; btn.textContent = 'Confirmar pedido →'; var e2 = document.getElementById('cod-error'); e2.style.display = 'block'; e2.textContent = res.j.error || 'No se pudo crear el pedido. Reintenta.'; }
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Confirmar pedido →'; });
  });
})();
